import React, { useEffect } from 'react';
import { Drawer, AppBar, Theme, createStyles, makeStyles, Toolbar } from '@material-ui/core';
import Router from './Components/Router/Router';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import Sidebar from './Components/Sidebar/Sidebar';
import moment from 'moment';
import './App.css';
import { I18n } from "aws-amplify"
import { vocabularies } from "./Components/I18n/I18n"
import i18next from "i18next"
import { initReactI18next, useTranslation } from "react-i18next"

import localeJa from "./Locales/ja.json"
import localeEn from "./Locales/en.json"

i18next.use(initReactI18next).init({
  resources: {
    ja: { translation: localeJa },
    en: { translation: localeEn },
  },
  fallbackLng: "ja",
  debug: true,
})

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    main: {
      paddingTop: 56, 
      paddingBottom: 56,
      [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: { 
        paddingTop: 48, 
        paddingBottom: 48,
      }, 
      [theme.breakpoints.up('sm')]: { 
        paddingTop: 64, 
        paddingBottom: 64,
      },
      minHeight: "100vh",
    },
    topBar: {
      top: 0
    },
    bottomBar: {
      top: 'auto',
      bottom: 0,
    },
  }),
);

function App() {

  const [updateAt, setUpdateAt] = React.useState(moment())
  const [sidebar, setSidebar] = React.useState(false)

  const classes = useStyles()
  const [,i18n] = useTranslation()

  const renew = ()=>setUpdateAt(moment())

  useEffect(()=>{
    console.log(i18n.language)
    I18n.putVocabularies(vocabularies)
    I18n.setLanguage(i18n.language || "ja")
  }, [i18n.language])

  return (
    <div className="App">
      <div className={classes.main}>
        <Router updateAt={updateAt} />
      </div>
      <AppBar position="fixed" className={classes.topBar}>
          <Header 
            onSidebarOpen={(e)=>setSidebar(true)} 
            onReload={()=>renew()} 
            updateAt={updateAt} />
      </AppBar>
      <AppBar position="fixed" color="default" className={classes.bottomBar}>
        <Toolbar>
          <Footer></Footer>
        </Toolbar>
      </AppBar>
      <Drawer open={sidebar} onClose={()=>setSidebar(false)}>
        <Sidebar 
          onSearch={(keyword)=>{
            setSidebar(false);
          }}
          updateAt={updateAt}
          />
      </Drawer>
    </div>
  );
}

export default App;
